<form [formGroup]="reactiveForm" >
    @let formReference = this.reactiveForm.controls;
    <div class="">
            <fieldset>
                <legend>Training Information</legend>
                <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">
                    <div>
                        <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Mobile*</mat-label>
                        <input matInput [formControl]="formReference.mobile"  type="number">
                        @if(formReference.mobile.invalid){
                        @for(err of this.getErrorMessages(formReference.mobile); track err){
                        <mat-error>
                        <small class="text-danger">{{err}}</small>
                        </mat-error>
                        }
                        }
                        </mat-form-field>
                        
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Email*</mat-label>
                        <input matInput [formControl]="formReference.email"  type="email">
                        @if(formReference.email.invalid){
                        @for(err of this.getErrorMessages(formReference.email); track err){
                        <mat-error>
                        <small class="text-danger">{{err}}</small>
                        </mat-error>
                        }
                        }
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Password*</mat-label>
                        <input matInput [formControl]="formReference.password"  [type]="hidePassword ? 'password' : 'text'">
                        <button mat-icon-button 
                                matSuffix 
                                (click)="hidePassword = !hidePassword" 
                                [attr.aria-label]="'Toggle password visibility'" 
                                [attr.aria-pressed]="!hidePassword" 
                                type="button">
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                         @if(formReference.password.invalid){
                        @for(err of this.getErrorMessages(formReference.password); track err){
                        <mat-error>
                        <small class="text-danger">{{err}}</small>
                        </mat-error>
                        }
                        }
                        </mat-form-field>
                    </div>
                </div> 
                <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">   
                    <div>
                        <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Training Code*</mat-label>
                        <input matInput [formControl]="formReference.trainingCode"  type="text">
                        </mat-form-field>
                    </div> 
                    
                    <div class="md:col-span-3">
                        <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Enter Training Title*</mat-label>
                        <input matInput  [formControl]="formReference.trainingTitle"  type="text">
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Type*</mat-label>
                            <mat-select  [formControl]="formReference.type" >
                                <mat-option value="1">WBSRLM</mat-option>
                                <mat-option value="2">Second option</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Category*</mat-label>
                            <mat-select [formControl]="formReference.category" >
                                <mat-option value="1">Agriculture</mat-option>
                                <mat-option value="2">Second option</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Sub Category*</mat-label>
                            <mat-select [formControl]="formReference.Subcategory" >
                                <mat-option value="1">Category-1</mat-option>
                                <mat-option value="2">Category-2</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!--div>
                        <mat-form-field appearance="outline" style="margin: 0!important;">
                            <mat-label>Residential*</mat-label>
                            <mat-select formControlName="levelbudget">
                                <mat-option value="Residential">Residential</mat-option>
                                <mat-option value="Non-residential">Non-residential</mat-option>
                                <mat-option value="Both">Both</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div-->
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Level*</mat-label>
                            <mat-select [formControl]="formReference.level" >
                                <mat-option value="1">SMMU</mat-option>
                                <mat-option value="2">DMMU</mat-option>
                                <mat-option value="3">BMMU</mat-option>
                                <mat-option value="4">Sangha Samabay</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Type of Participants*</mat-label>
                            <mat-select [formControl]="formReference.participantsType" >
                                <mat-option value="new">New</mat-option>
                                <mat-option value="refresher">Refresher</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Duration*</mat-label>
                            <mat-select [formControl]="formReference.duration" >
                                <mat-option value="1">1 Day</mat-option>
                                <mat-option value="2">2 Day's</mat-option>
                                <mat-option value="3">3 Day's</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Mode of Training*</mat-label>
                            <mat-select [formControl]="formReference.mode" >
                                <mat-option value="Online">Online</mat-option>
                                <mat-option value="Offline">Offline</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Training Frequency*</mat-label>
                            <mat-select [formControl]="formReference.frequency" >
                                <mat-option value="1">1 Month</mat-option>
                                <mat-option value="2">2 Month's</mat-option>
                                <mat-option value="3">3 Month's</mat-option>
                                <mat-option value="4">4 Month's</mat-option>
                                <mat-option value="5">5 Month's</mat-option>
                                <mat-option value="6">6 Month's</mat-option>
                                <mat-option value="7">7 Month's</mat-option>
                                <mat-option value="8">8 Month's</mat-option>
                                <mat-option value="9">9 Month's</mat-option>
                                <mat-option value="10">10 Month's</mat-option>
                                <mat-option value="11">11 Month's</mat-option>
                                <mat-option value="12">12 Month's</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Budget Head*</mat-label>
                            <mat-select [formControl]="formReference.budgetHead">
                                <mat-option value="B.1.2.4">B.1.2.4</mat-option>
                                <mat-option value="B.1.2.5">B.1.2.5</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Residential*</mat-label>
                            <mat-select [formControl]="formReference.residential" >
                                <mat-option value="one">Residential</mat-option>
                                <mat-option value="two">Non Residential</mat-option>
                                <mat-option value="Both">Both</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </fieldset>

            <fieldset class="mt-3">
                <legend>Participants Expenses</legend>
                <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Residential Amount*</mat-label>
                            <input matInput type="number" [formControl]="formReference.residentialAmount"  >
                            <!-- Error messages -->
                            @if(formReference.residentialAmount.invalid){
                                @for(err of this.getErrorMessages(formReference.residentialAmount); track err){
                                    <mat-error>
                                    <small class="text-danger">{{err}}</small>

                                    </mat-error>
                                }
                            }
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Non Residential Amount*</mat-label>
                            <input matInput type="number" [formControl]="formReference.nonResidentialAmount"  >
                            <!-- Error messages -->
                            @if(formReference.nonResidentialAmount.invalid){
                                @for(err of this.getErrorMessages(formReference.nonResidentialAmount); track err){
                                    <mat-error>
                                    <small class="text-danger">{{err}}</small>

                                    </mat-error>
                                }
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-span-2 md:col-span-1">
                        <mat-form-field appearance="outline">
                            <mat-label>Memo No.</mat-label>
                            <input matInput type="text" [formControl]="formReference.memoNo" >
                        </mat-form-field>
                    </div>
                
                </div>
            </fieldset>

           
            <!-- Training Content -->
            <fieldset class="mt-3">
            <legend>Training Content</legend>
            <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">
                <!-- Training Kit -->
                <!-- <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Training Kit</mat-label>
                        <input type="text" matInput placeholder="Choose a file" readonly />
                        <a mat-icon-button matSuffix>
                        <mat-icon>attach_file</mat-icon>
                        </a>
                        
                    </mat-form-field>
                     <input type="file" #fileInputKit/> 
                </div> -->
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Training Kit</mat-label>
                        <input type="text" matInput [value]="kitFileName" placeholder="Choose a file" readonly />
                        <a mat-icon-button matSuffix (click)="fileInputKit.click()">
                        <mat-icon>attach_file</mat-icon>
                        
                        
                        </a>
                         
                        <!-- Error messages -->
                        @if(formReference.kitFile.invalid){
                            @for(err of this.getErrorMessages(formReference.kitFile); track err){
                                <mat-error>
                                <small class="text-danger">{{err}}</small>

                                </mat-error>
                            }
                        }  
                    </mat-form-field>
                    <input type="file" #fileInputKit (change)="onFileSelected($event, 'kitFile')" hidden />
                   
                </div>

                <!-- Training Material -->
                <!--<div>
                <mat-form-field appearance="outline">
                    <mat-label>Training Material</mat-label>
                    <input type="text" matInput placeholder="Choose a file" readonly />
                    <a mat-icon-button matSuffix>
                    <mat-icon>attach_file</mat-icon>
                    </a>
                </mat-form-field>
                 <input type="file" #fileInputMaterial /> 
                </div-->
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Training Material</mat-label>
                        <input type="text" matInput [value]="materialFileName" placeholder="Choose a file" readonly />
                        <a mat-icon-button matSuffix (click)="fileInputMaterial.click()">
                        <mat-icon>attach_file</mat-icon>
                        
                        </a>
                        
                        <!-- Error messages -->
                        @if(formReference.materialFile.invalid){
                            @for(err of this.getErrorMessages(formReference.materialFile); track err){
                                <mat-error>
                                <small class="text-danger">{{err}}</small>

                                </mat-error>
                            }
                        }
                    </mat-form-field>
                    <input type="file" #fileInputMaterial (change)="onFileSelected($event, 'materialFile')" hidden />
                </div>

                <!-- Refreshment -->
                <div class="col-span-2 md:col-span-1">
                    <mat-form-field appearance="outline">
                        <mat-label>Refreshment Needed*</mat-label>
                        <mat-select [formControl]="formReference.refreshment" >
                        <mat-option value="yes">Yes</mat-option>
                        <mat-option value="no">No</mat-option>
                        </mat-select>
                        <!-- Error messages -->
                        @if(formReference.refreshment.invalid){
                            @for(err of this.getErrorMessages(formReference.refreshment); track err){
                                <mat-error>
                                <small class="text-danger">{{err}}</small>

                                </mat-error>
                            }
                        }
                    </mat-form-field>
                </div>
            </div>
            </fieldset>

            <fieldset class="mt-3">
                <legend>Active Status</legend>
                <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">
                    <div class="pt-2">
                        <mat-slide-toggle [formControl]="formReference.active" >Active</mat-slide-toggle> 
                    </div>
                    <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Inactive Form</mat-label>
                            <input matInput [matDatepicker]="picker" [formControl]="formReference.inactiveFrom" >
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <!-- Error messages -->
                            @if(formReference.inactiveFrom.invalid){
                                @for(err of this.getErrorMessages(formReference.inactiveFrom); track err){
                                    <mat-error>
                                    <small class="text-danger">{{err}}</small>

                                    </mat-error>
                                }
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-span-2">
                        <mat-form-field appearance="outline">
                            <mat-label>Remarks</mat-label>
                            <textarea cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" matInput [formControl]="formReference.remarks" ></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </fieldset>

        </div>
        <div class="flex flex-row justify-center space-x-3 my-4">
            
            <div>
                <button type="button" (click)="goBack()" >
                    <div class="signup-btn flex space-between-3">
                        <i class="material-symbols-outlined">
                            arrow_left_alt
                        </i>
                        Go Back
                    </div>
                </button>
            </div>
            <div>
                <button type="button" (click)="refreshForm()">
                    <div class="signup-btn flex space-between-3">
                        <i class="material-symbols-outlined">
                            refresh
                        </i>
                        Refresh
                    </div>
                </button>
            </div>
            <div>
                <button type="submit" [disabled]="reactiveForm.invalid">
                    <div class="signup-btn flex space-between-3">
                        <i class="material-symbols-outlined">
                            save
                        </i>
                        Save
                    </div>
                </button>
            </div>
        </div>
</form>